import { useState } from "react";
import { Dialog } from "~/components/ui/dialog";
import { useReducedMotion } from "~/hooks/useReducedMotion";
import { useCommandBar } from "./CommandBarContext";
import { CommandPalette } from "./CommandPalette";
import { COMMAND_BAR_TOP_MARGIN } from "./constants";

/**
 * The command palette raised over the page by Cmd/Ctrl+K, Quick search in the
 * sidebar and Search in the top bar: one Ledger Dialog, size md (640), placed
 * in the upper third of the window, with its own title for assistive
 * technology.
 *
 * This file is the SURFACE only: a dialog, and the way it steps aside when a
 * question is handed to Langy. Everything the palette does — search,
 * navigation, recents, the Langy hand-off — lives in `CommandPalette`, which
 * the project home mounts inline as well. Two places to type, one set of
 * behaviours.
 *
 * Spec: specs/design-system/ledger-shell.feature
 */
export function CommandBar() {
  const { isOpen, close, query, setQuery } = useCommandBar();
  const reduceMotion = useReducedMotion();
  const [handingOff, setHandingOff] = useState(false);

  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={({ open }) => !open && close()}
      placement="top"
      size="md"
    >
      <Dialog.Content
        aria-label="Command palette"
        marginTop={{ base: "var(--space-6)", md: COMMAND_BAR_TOP_MARGIN }}
        padding={0}
        overflow="hidden"
        data-langy-handoff={handingOff ? "exiting" : undefined}
        style={{
          opacity: handingOff ? 0 : 1,
          transition: reduceMotion
            ? undefined
            : "opacity var(--dur-2) var(--ease-in)",
        }}
      >
        <CommandPalette
          surface="dialog"
          active={isOpen}
          query={query}
          setQuery={setQuery}
          onDone={close}
          onHandoffStateChange={setHandingOff}
        />
      </Dialog.Content>
    </Dialog.Root>
  );
}
